import axios from 'axios'
import config from '../config'
import { getUserToken } from "../utils"

const changeEmployeeStatusApi = async(params) => {
    console.log("changeEmployee");
    const response = await axios({
        url: `${config.api.base_url}employee/change-status`,
        method: "put",
        data: params,
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${getUserToken()}`
        }
    })

    return response

}

export default changeEmployeeStatusApi